import { customAxios } from '@/utils/api/dataUtils';
import { jwtDecode } from 'jwt-decode';

// import { errorCode } from '@/constants/httpError.js';
import useAuthStore from '@/store/auth';
import { onUnmounted } from 'vue';
import { useRouter } from 'vue-router';

import { getRefreshToken } from '@/apis/auth';
// import { useI18n } from 'vue-i18n';
import CommonStore from '@/store/commonStore';

export const useAxiosInterceptor = () => {
  const { errMsg, errState } = CommonStore();
  const router = useRouter();
  const authStore = useAuthStore();

  // const i18n = useI18n();

  // refreshToken 요청을 위한 Promise 저장 변수
  let isRefreshing = false;
  let refreshSubscribers = [];

  // 대기중인 요청들을 처리하는 함수
  const processQueue = (token = null) => {
    refreshSubscribers.forEach((callback) => callback(token));
    refreshSubscribers = [];
  };

  const requestHandler = async (config) => {
    // 토큰 처리를 위한 AuthStore 호출

    // 외부 API 호출시 불필요한 값 제외
    const url = config.url;
    if (!url.includes('http')) {
      // Header 토큰 추가
      config.headers[
        'Authorization'
      ] = `Bearer ${authStore.authInfo.value.accessToken}`;
    }

    // 다국어 요청을 위한 Accpet-Language 설정
    // const locale = i18n.locale.value;

    // config.headers['Accept-Language'] = `${locale.toUpperCase()};`;

    return config;
  };

  const errorHandler = async (res) => {
    const url = res.config.url;
    const params = res.config.params;
    const data = res.config.data;

    // TODO: 개발일때만 사용하도록
    // let copyText = `url: ${url}, `;
    // copyText += params ? `params : ${JSON.stringify(params)}` : '';
    // copyText += data ? `data : ${JSON.stringify(data)}` : '';
    // navigator.clipboard.writeText(copyText).then(
    //   () => {},
    //   () => {}
    // );
    // console.log('ERROR : ', res.data.exception);

    // slack 요청은 예외처리
    if (url.includes('slack')) {
      return res;
    }

    if (res.status === 401 && !url.includes('refresh')) {
      const retryOriginalRequest = new Promise((resolve) => {
        refreshSubscribers.push((token) => {
          res.config.headers['Authorization'] = `Bearer ${token}`;
          resolve(customAxios(res.config));
        });
      });
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const params = {
            refreshToken: authStore.authInfo.value.refreshToken
          };
          const refreshResult = await getRefreshToken(params);
          if (refreshResult.status === 201) {
            const newToken = refreshResult.data.accessToken;
            authStore.tokenUpdate.value(refreshResult.data);
            processQueue(newToken);
          }
        } catch (error) {
          console.log('refresh error');
          refreshSubscribers = [];
          authStore.logout.value();
          router.push('/login');
        } finally {
          isRefreshing = false;
        }
      }
      return retryOriginalRequest;
    } else if (res.status === 401) {
      refreshSubscribers = [];
      authStore.logout.value();
      router.push('/login');
    } else if (res.status === 404) {
      // TODO : 500에러 처리가 필요한지?
    } else if (res.status === 409) {
      errMsg.value.message = res.data.message;
      errState.value = true;
    } else if (res.status === 413) {
      // toast.error('파일 크기가 너무 큽니다.');
    } else {
      // toast.error('알 수 없는 오류가 발생했습니다.');
    }

    if (res.status !== 401 && res.status !== 429) {
      console.error('Axios Error:', res);
    }

    return res;
  };

  const responseHandler = (response) => {
    // if (response.config.method !== "get") {
    // }
    return response;
  };

  const responseInterceptor = customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error.response)
  );

  const requestInterceptor =
    customAxios.interceptors.request.use(requestHandler);

  onUnmounted(() => {
    customAxios.interceptors.request.eject(requestInterceptor);
    customAxios.interceptors.response.eject(responseInterceptor);
  });
};
